import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import formStyles from '../form.module.css'
import styles from './select-list.module.css'
import Iconify from '../../../../Iconify'
import iconoBanco from '../../../assets/icono-banco.png'

export const SelectList = ({
  name = '',
  label = '',
  helpText = '',
  required = false,
  icon = '',
  showActiveEndIcon = false,
  placeholder = '',
  options = [],
  disabled = false,
  autoFocus = false
}) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={placeholder ? '' : undefined}
      render={({ field, fieldState }) => {
        const describedBy = [
          fieldState.error ? `${name}-error` : null,
          helpText ? `${name}-help` : null
        ]
          .filter(Boolean)
          .join(' ')

        const valueProp =
          field.value != null && field.value !== ''
            ? String(field.value)
            : ''
        const isPlaceholderActive = Boolean(placeholder) && valueProp === ''
        const activeOption = options.find(
          (option) => String(option.key) === valueProp
        )
        const activeEndIcon = showActiveEndIcon
          ? activeOption?.activeEndIcon
          : null

        return (
          <div className={formStyles.field}>
            <label className={formStyles.label} htmlFor={name}>
              {label}{' '}
              {required && <span className={formStyles.required}>*</span>}
            </label>

            <div
              className={`${formStyles.shell} ${fieldState.error ? styles.shellInvalid : ''}`}
            >
              <span className={formStyles.prefix}>
                <img src={iconoBanco} alt="Banco" height={17} />
              </span>
              <select
                id={name}
                ref={field.ref}
                name={field.name}
                className={styles.select}
                style={isPlaceholderActive ? { color: '#666666' } : undefined}
                value={valueProp}
                onBlur={field.onBlur}
                onChange={(e) => field.onChange(e.target.value)}
                disabled={disabled}
                autoFocus={autoFocus}
                aria-invalid={fieldState.error ? 'true' : 'false'}
                aria-describedby={describedBy || undefined}
              >
                {placeholder ? (
                  <option value="">{placeholder}</option>
                ) : null}
                {options.map((option) => (
                  <option key={String(option.key)} value={String(option.key)}>
                    {option.label}
                  </option>
                ))}
              </select>
              {icon || activeEndIcon ? (
                <span
                  aria-hidden
                  style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                >
                  {icon ? (
                    <span className={styles.suffix}>
                      <Iconify icon={icon} style={{ fontSize: 22, color: '#97ff48' }} />
                    </span>
                  ) : null}
                  {activeEndIcon ? (
                    <span className={styles.suffix}>
                      <Iconify
                        icon={activeEndIcon}
                        style={{ fontSize: 22, color: '#97ff48' }}
                      />
                    </span>
                  ) : null}
                </span>
              ) : null}
            </div>

            {fieldState.error ? (
              <p id={`${name}-error`} className={formStyles.error} role="alert">
                {fieldState.error.message}
              </p>
            ) : null}

            {helpText ? (
              <p id={`${name}-help`} className={formStyles.helpText}>
                {helpText}
              </p>
            ) : null}
          </div>
        )
      }}
    />
  )
}
